module.exports = __webpack_public_path__ + "img/drag-icon.28206d1c.svg";